module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-f4746878.png";